<template>
	<!-- MAIN MODAL -->
	<b-modal :id="domID" cancel-disabled ok-disabled scrollable :title="(!form.id_pk) ? labelsCfg.newLabel : form.nombre" size="xl" no-enforce-focus @hidden="hidden">
		<b-form @submit="onSubmit">

			<b-row>
				<b-col id="formHolder" md="4">

					<!-- NOMBRE -->
					<b-form-group label="* Nombre de la receta:" label-for="form-nombre">
						<b-form-input id="form-nombre" v-model="form.nombre" required />
					</b-form-group>
					<!-- NOMBRE -->

					<!-- PORCION -->
					<b-form-group label="* Porción:" label-for="form-porcion">
						<b-form-input id="form-porcion" type="number" step="1" v-model="form.porcion" required />
					</b-form-group>
					<!-- PORCION -->

					<!-- TIEMPO_PREPARACION -->
					<b-form-group label="* Tiempo de preparación:" label-for="form-tiempo_preparacion">
						<b-form-select id="form-tiempo_preparacion" v-model="form.tiempo_preparacion" required :options="tiempoPreparacionOpciones" />
					</b-form-group>

					<b-form-group label="* Tiempo de cocción:" label-for="form-tiempo_coccion">
						<b-form-select id="form-tiempo_coccion" v-model="form.tiempo_coccion" required :options="tiempoPreparacionOpciones" />
					</b-form-group>
					<!-- TIEMPO_PREPARACION -->

					<!-- CÁLCULO DE ELEMENTOS NUTRICIONALES -->
					<b-form-group label="Orígen del cálculo de los elementos nutricionales:" label-for="form-origen_calculo_nutricional">
						<b-form-select v-model="form.origen_calculo_nutricional" name="origen_calculo_nutricional" :options="calculoNutricionalOpts" />
					</b-form-group>


					<!-- SWITCH SIMPLE -->
					<b-form-checkbox v-model="form.desayuno" class="mt-3 mb-3" name="check-button" value="1" unchecked-value="0" switch>
						<span>Desayuno</span>
					</b-form-checkbox>
					<b-form-checkbox v-model="form.comida" class="mt-3 mb-3" name="check-button" value="1" unchecked-value="0" switch>
						<span>Comida</span>
					</b-form-checkbox>
					<b-form-checkbox v-model="form.cena" class="mt-3 mb-3" name="check-button" value="1" unchecked-value="0" switch>
						<span>Cena</span>
					</b-form-checkbox>

					<!-- SWITCH SIMPLE -->
					<b-card bg-variant="light">

						<!-- COMPARTIR -->
						<b-form-group label="* Compartir:" label-for="form-compartir">
							<b-form-select id="form-compartir" v-model="form.compartir" :options="compartirConf" required />
						</b-form-group>
						<!-- COMPARTIR -->

						<!-- CALIFICACIÓN -->
						<b-form-group label="* Calificación:" label-for="form-numero_estrellas">
							<b-form-select id="form-numero_estrellas" v-model="form.numero_estrellas" :options="estrellasConf" required />
						</b-form-group>
						<!-- CALIFICACIÓN -->

						<!-- ESTATUS -->
						<b-form-group label="* Estatus:" label-for="form-estatus">
							<b-form-select id="form-estatus" v-model="form.estatus" :options="estatusConf" required />
						</b-form-group>
						<!-- ESTATUS -->

						<!-- BANDERA -->
						<b-form-group label="Bandera:" label-for="form.bandera">
							<b-form-select id="form.bandera" v-model="form.bandera" :options="banderaConf" />
						</b-form-group>
						<!-- BANDERA -->

					</b-card>

					<!-- textaread simple -->
					<b-form-group label="Observaciones:" label-for="form-observaciones">
						<b-form-textarea id="form-observaciones" v-model="form.observaciones"></b-form-textarea>
					</b-form-group>
					<!-- textaread simple -->

				</b-col>
				<b-col id="contentHolder" md="8">

					<!-- STORAGE IMG UPLOADER -->
					<b-card id="imgHolder" bg-variant="light">
						<storage-img-uploader v-model="form.imagen" label="Imágen de receta" />
					</b-card>
					<!-- STORAGE IMG UPLOADER -->

					<b-card id="tabHolder" no-body>
						<b-tabs id="mainTab" pills card>

							<b-tab title="Ingredientes" active>
								<receta-ingredientes-handler v-model="form.asides.encabezadoingrediente" @canBeUpdated="updateNutritionalsCanBeAutomatic"/>
							</b-tab>

							<b-tab title="Pasos">
								<receta-pasos-handler v-model="form.asides.paso" />
							</b-tab>

							<b-tab title="Clasificadores">
								<b-row id="TabClasificadores">
									<b-col  md="7" id="CategoriasRecetas">
										<b-list-group>
											<b-list-group-item v-for="valorc in selectableCategoriasRecetas" :key="valorc.id_pk" class="d-flex justify-content-between align-items-center" :active="form.asides.selection == valorc.id_pk" @click="form.asides.selection = valorc.id_pk" button>
												{{valorc.nombre}}
												<b-badge variant="primary" v-if="valorc.clasificadoresSelected" pill>
													{{valorc.clasificadoresSelected}}
												</b-badge>
											</b-list-group-item>
										</b-list-group>
									</b-col>
									<b-col id="ClasificadoresRecetas" v-if="selectableClasificadorvalor.length">
										<b-list-group>
											<b-list-group-item v-for="clasif in selectableClasificadorvalor" :key="clasif.id_pk" @click="toggleClasificdorValor(clasif.id_pk)" :active="form.asides.valor.indexOf(clasif.id_pk) != -1" button>
												{{clasif.nombre}}
											</b-list-group-item>
										</b-list-group>
									</b-col>
								</b-row>
							</b-tab>

							<b-tab title="Nutricionales">
								<receta-nutricionales v-model="form.asides.nutricionales" :unidadmedicion="asidesCats.unidadmedicion" :elementonutricional="asidesCats.elementonutricional" />
							</b-tab>

						</b-tabs>
					</b-card>

				</b-col>
			</b-row>

		</b-form>

		<template v-slot:modal-footer="{ cancel }">
			<template v-if="!isProcessing && !!form.id_pk">
				<b-button size="sm" variant="outline-danger" @click="tryToDelete(form.id_pk)" v-if="!isProcessing && !!form.id_pk">
					<i class="fa fa-trash"></i>
					{{labelsCfg.btnDelete}}
				</b-button>

				<b-button size="sm" variant="warning" v-if="!isProcessing" @click="ask4Clone()">
					Clonar receta
				</b-button>
			</template>

			<b-button size="sm" @click="cancel()" v-if="!isProcessing">{{labelsCfg.btnCancel}}</b-button>


			<!-- Button with custom close trigger value -->
			<b-button size="sm" :variant="variant" @click="store()" v-if="!isProcessing">
				{{labelsCfg.btnApply}}
			</b-button>

			<!-- Button with custom close trigger value -->
			<b-button size="sm" :variant="variant" disabled v-if="isProcessing">
				<span key="spin"> <i class="fa fa-cog fa-spin"></i> </span> 
				{{labelsCfg.btnIsProcessing}}
			</b-button>
		</template>
	</b-modal>
	<!-- MAIN MODAL -->
</template>

<script>
import axios from "axios";
import _ from "lodash";
import swal from "sweetalert";
import fkSelect from "@/views/elements/fk-select.vue";
import imgInputAutoload from "@/views/elements/img-input-autoload.vue";
import mobiscroll from "@mobiscroll/javascript";
import md5 from "js-md5";
import moment from 'moment'
import { mapGetters } from 'vuex';
import RecetaIngredientesHandler from './RecetaIngredientesHandler.vue'
import RecetaPasosHandler from './RecetaPasosHandler.vue'
import RecetaNutricionales from './RecetaNutricionales.vue'

let dataSource = "nutricion/encabezado"; // Para crear, actualizar y borrar

let estrellasConf = [
	{value: 1, text: '1 Estrella'},
	{value: 2, text: '2 Estrellas'},
	{value: 3, text: '3 Estrellas'},
	{value: 4, text: '4 Estrellas'},
	{value: 5, text: '5 Estrellas'},
]

let estatusConf = [
	{value: 1, text: 'Activo'},
	{value: 0, text: 'Inactivo'},
]

let banderaConf = [
	{value: 1, text: 'Es cliente'},
	{value: 2, text: 'Es usuario'},
]

let formArchetype = {

	// SYS
	id_pk: null,
	id_usuario_fk: null,
	id_ultimo_usuario_fk: null,
	ultima_actualizacion: null,

	// FORM
	nombre: null,						// TEXT
	porcion: 1,							// INT
	tiempo_preparacion: '00:00',		// INT
	tiempo_coccion: '00:00',			// INT
	desayuno: '0',						// BOOLEAN
	comida: '0',						// BOOLEAN
	cena: '0',							// BOOLEAN
	imagen: null,						// REMOTE FILE
	numero_estrellas: 3,				// OPTION
	estatus: '1',						// OPTION
	compartir: 'p',						// OPTION
	bandera: 2,							// OPTION
	observaciones: null,				// TEXTAREA
	origen_calculo_nutricional: null,	// ORGIEN SELECT

	// ASIDES
	asides: {
		encabezadoingrediente: [],	// ALMENOS 1 PARA QUE FUNCIONE LA COSA.
		paso: [],					// PASO PARA LA RECETA
		valor: [],
		nutricionales: [],			// CONFIGURACIÓN DE ELEMENTOS NUTRICIONALES
		selection: null
	}
};

let labelsCfg = {
	emptyHeader: "Lista vacía",
	emptyLead: "",
	searchPlaceholder: "Buscador...",
	newLabel: "Nueva receta",
	btnDelete: "Eliminar",
	btnCancel: "Cancelar",
	btnApply: "Aplicar",
	btnIsProcessing: "Procesando...",
};

export default {
	name: "RecetaMainModal",
	props: {},

	components: {
		fkSelect,
		imgInputAutoload,
		RecetaIngredientesHandler, 
		RecetaPasosHandler, 
		RecetaNutricionales
	},

	computed: {
		...mapGetters({
			authGetUser: 'authGetUser',
			compartirConf: 'uiGetCompartirConf'
		}),
		tiempoPreparacionOpciones(){
			return [
				"00:00",
				"00:01",
				"00:02",
				"00:03",
				"00:04",
				"00:05",
				"00:06",
				"00:07",
				"00:08",
				"00:09",
				"00:10",
				"00:15",
				"00:20",
				"00:25",
				"00:30",
				"00:35",
				"00:40",
				"00:45",
				"00:50",
				"00:55",
				"01:00",
				"01:15",
				"01:30",
				"01:45",
				"02:00",
				"02:15",
				"02:30",
				"02:45",
				"03:00",
				"03:15",
				"03:30",
				"03:45",
				"04:00",
				"04:15",
				"04:30",
				"04:45",
				"05:00",
				"05:15",
				"05:30",
				"05:45",
				"06:00",
				"06:15",
				"06:30",
				"06:45"
			]
		},
		selectableCategoriasRecetas(){
			let ret = _.forEach(this.asidesCats.categoriareceta, item => {
				let clasificadore = _.filter(this.asidesCats.clasificadorvalor, {idclasificador_fk: item.id_pk})
				let selected = _.filter(this.asidesCats.clasificadorvalor, clasif => {
					return (item.id_pk == clasif.idclasificador_fk && this.form.asides.valor.indexOf(clasif.id_pk) != -1)
				})
				item.clasificadoresCount = clasificadore.length
				item.clasificadoresSelected = selected.length
				return item;
			})
			return _.filter(ret, item => {return (item.clasificadoresCount>0)})
		},
		selectableClasificadorvalor(){
			let ret = []
			if(!!this.form.asides.selection){
				ret = _.filter(this.asidesCats.clasificadorvalor, {idclasificador_fk: this.form.asides.selection})
			}
			return ret
		},
		items() {
			return _.map(this.data.rows, (item) => {
				item._ = " ";
				return item;
			});
		},
		dataMD5() {
			return md5(JSON.stringify(this.form));
		},
		calculoNutricionalOpts(){
			let resp = [
				'Manual',
				// Ingredientes
			]
			if(this.nutritionalsCanBeAutomatic){
				resp.push('Ingredientes')
			}
			return resp
		}
	},

	data: () => {
		return {
			domID: null,
			isLoading: false,
			isProcessing: false,
			term: null,
			variant: "primary",
			dataSource,
			estrellasConf, estatusConf, banderaConf, 
			labelsCfg: _.cloneDeep(labelsCfg),
			originalData: _.cloneDeep(formArchetype),
			form: _.cloneDeep(formArchetype),
			nutritionalsCanBeAutomatic: true,
			asidesCats: {
				categoriareceta: [],
				unidadmedicion: [],
				elementonutricional: [],
				clasificadorvalor: []
			},
			data: {
				rows: [],
				count: 0,
				per_page: 25,
				page: 1,
			},
		};
	},

	methods: {

		// Update nutritionalsCanBeAutomatic value
		updateNutritionalsCanBeAutomatic(canBe){
			// alert('this.computedGeneralValidation: ' + canBe)
			this.nutritionalsCanBeAutomatic = canBe
			if(!this.nutritionalsCanBeAutomatic){
				this.form.origen_calculo_nutricional = this.calculoNutricionalOpts[0]
			}
		},

		// triggerCloning
		async triggerCloning(){
			try {
				let response = await axios.get('nutricion/clonareceta/' + this.form.id_pk)
				if(response.status){
					await Promise.all([
						this.loadUp(),
						this.loadItem(response.data.cloned_id)
					])
					swal({
						icon:'success',
						title: 'Receta clonada exitosamente.'
					})
				} else if (response.msg) {
					mobiscroll.snackbar({
						display: 'top',
						theme: 'ios',
						message: response.msg,
						color: response.class,
						duration: 7000
					})
				}
			} catch(e){
				console.error(e)
				mobiscroll.snackbar({
					display: 'top',
					theme: 'ios',
					message: 'Ocurrió un error obteniendo la respuesta: ' + e,
					color: 'warning',
					duration: 7000
				})
			}
		},

		// CLONE ASK
		async ask4Clone(){
			let response = await swal({
				icon: 'warning',
				title: 'Estás apunto de clonar ésta receta',
				text: 'Al clonarla, la copia se cargará en ésta ventana y se establecerá como oculta',
				buttons: {
					cancel: 'Cancelar',
					warning: 'Si, generar clon'
				}
			})
			if(response){
				this.isProcessing = true
				await this.triggerCloning()
				this.isProcessing = false
			}
		},

		// AGREGA O RUEMVE UN ID DE CLASIFICADOR VALOR
		toggleClasificdorValor(id_pk){
			let indexOfPos = this.form.asides.valor.indexOf(id_pk);
			if(indexOfPos == -1)
				this.form.asides.valor.push(id_pk)
			else 
				this.form.asides.valor.splice(indexOfPos, 1)
		},

		// PREGUNTA Y CONTINÚA CON EL BORRADO DEL REGISTRO
		async tryToDelete(itemID) {
			if (!!itemID) {
				const swalResponse = await swal({
					text: "¿Estás seguro que deseas eliminar éste registro?",
					icon: "info",
					buttons: {
						cancel: "Cancelar",
						danger: "Si, bórrala",
					},
				})
				if (swalResponse == "danger") {
					// HE SAID YES!
					this.isProcessing = true;
					const response = await axios.delete(this.dataSource + "/" + itemID)
					if (response.status) {
						this.loadUp().then(() => {
							this.$bvModal.hide(this.domID);
							this.isProcessing = false;
						});
					} else {
						this.isProcessing = false;
					}
				}
			} else {
				swal({
					text: "Para poder eliminar un registro, éste debe especifcar un ID de eliminación.",
				});
			}
		},

		// PREPARA LO QUE TENGAS QUE PREPARAR PARA SUBIR AL SERVIDIOR,
		// COMO AGREGAR VALIDACIONES, DATOS O PROPIEDADES DINÁMICAS, ETC.
		// DEVULEVE FALSO PARA DETENER EL ENVÍO
		getDataForSubmit() {
			let data = _.cloneDeep(this.form);
			
			_.forEach(
				[
					'nombre',
					'porcion',
					'numero_estrellas',
					'compartir',
					'bandera',
					'estatus'
				],
				(keyRequired) => {
					if (typeof data == "object" && !data[keyRequired]) {
						swal({
							text: "Asegúrate de llenar todos los campos con *.",
						});
						data = false;
					}
				}
			);
			
			// VALIDACIÓN RÁPIDA
			if(!data.id_pk){
				data.id_usuario_fk = this.authGetUser.id_pk
			}

			data.id_ultimo_usuario_fk = this.authGetUser.id_pk

			_.map(['tiempo_preparacion', 'tiempo_coccion'], lab => {
				data[lab] = moment(data[lab], 'HH:mm').diff(moment('00:00', 'HH:mm'), 'minutes')
			})

			data.ultima_actualizacion = moment().format('YYYY-MM-DD HH:mm:ss')

			return data;
		},

		openForNew() {
			this.form = _.cloneDeep(formArchetype);
			this.$bvModal.show(this.domID);
		},

		async loadItem(id_pk) {
			this.isLoading = true;
			try {
				const response = await axios.get(dataSource + "/" + id_pk);
				// ANALIZA SI HAY MENSAJES PARA EL USUARIO, duración extendia.
				if (response.msg) {
					mobiscroll.snackbar({
						display: "top",
						theme: "ios",
						message: response.msg,
						color: response.class,
						duration: 7000,
					});
				}
				if (response.status) {
					this.originalData 				= _.cloneDeep(response.data.encabezado);
					let data4Form 					= _.cloneDeep(response.data.encabezado);
					data4Form.tiempo_preparacion	= moment().hour(0).minute(0).add((response.data.encabezado.tiempo_preparacion), 'minute').format('HH:mm')
					data4Form.tiempo_coccion		= moment().hour(0).minute(0).add((response.data.encabezado.tiempo_coccion), 'minute').format('HH:mm')
					data4Form.asides				= response.data.asides
					data4Form.asides.selection		= null
					this.form 						= data4Form
				}
			} catch (e) {
				console.error(e);
				mobiscroll.snackbar({
					display: "top",
					theme: "ios",
					message: "Ocurrió un error obteniendo la respuesta: " + e,
					color: "warning",
					duration: 7000,
				});
			}
			this.isLoading = false;
			// this.form = _.cloneDeep(item)
			this.$bvModal.show(this.domID);
		},

		async refresh() {
			this.isLoading = true;
			await this.loadUp();
			this.isLoading = false;
		},

		async loadUp() {
			if(typeof this.$parent.loadUp == 'function')
			await this.$parent.loadUp();
		},

		hidden() {
			this.form = _.cloneDeep(formArchetype);
			this.$bvModal.hide(this.domID);
		},

		async store() {
			let data2send = this.getDataForSubmit();
			if (!!data2send) {
				this.isProcessing = true;
				const response = await axios.post( this.dataSource + (!!this.form.id_pk ? "/" + this.form.id_pk : ""), data2send )

				if (response.status) {
					await this.loadUp();
					this.hidden()
				}
				this.isProcessing = false;
			}
		},

		onSubmit($evnt) {
			$evnt.preventDefault();
			this.store();
		},

		async loadAsidesCats() {
			try {
				const response = await axios.get('nutricion/getasidecatalogs')
				// ANALIZA SI HAY MENSAJES PARA EL USUARIO, duración extendia.
				if (response.msg) {
					mobiscroll.snackbar({
						display: 'top',
						theme: 'ios',
						message: response.msg,
						color: response.class,
						duration: 7000
					})
				}
				if(response.status) {
					this.asidesCats.categoriareceta = response.data.categoriareceta
					this.asidesCats.clasificadorvalor = response.data.clasificadorvalor
					this.asidesCats.unidadmedicion = response.data.unidadmedicion
					this.asidesCats.elementonutricional = response.data.elementonutricional
				}
			} catch(e) {
				console.error(e)
				mobiscroll.snackbar({
					display: 'top',
					theme: 'ios',
					message: 'Ocurrió un error los catálogos base: ' + e,
					color: 'warning',
					duration: 7000
				})
			}
		}
	},

	async beforeMount() {
		this.domID = _.uniqueId("RecetaMainModal-");
		this.isLoading  = true
		await this.loadAsidesCats()
		this.isLoading  = false
	}
};
</script>